function build({ childId, seeTasks } = {}) {
  if (seeTasks) {
    return `/admin/cases/child/${childId}`;
  }

  return '/admin/cases';
}

export default build;
